import cookie from '@/plugins/cookie';
const TokenKey = 'AutoInfoEnglish-Token'

export function getToken() {
    return cookie.get(TokenKey)
}

export function setToken(token) {
    let time = new Date(new Date().getTime() + 30 * 60 * 1000);

    return cookie.set(TokenKey, token,{ expires: time })
}

export function removeToken() {
    return cookie.remove(TokenKey)
}
export function set (key, value) {
    if (!sessionStorage) {
        return
    }
    if (key != null && value != null) {
        sessionStorage.setItem(key, value)
    }
}
export function get (key) {
    if (!sessionStorage) {
        return null
    }
    if (key == null) {
        return null
    }
    return sessionStorage.getItem(key)
}
export function remove (key) {
    sessionStorage.removeItem(key)
}
// 校验Token是否过期
export function isTokenValid() {
    if (!TokenKey) return false;
    try {
        console.log("111"+TokenKey)
        const payload = JSON.parse(atob(TokenKey.split('.')[1])); // 解码JWT payload
        console.log(payload)
        return payload.exp > Date.now() / 1000; // 检查过期时间
    } catch (error) {
        return false;
    }
}


/**获取用户信息 */
export function getUserInfo() {
    const info = cookie.get('userInfo');
    // const info = cookie.get('userInfo');
    return info ? JSON.parse(info) : null;
}

/**判断用户是否为“商用车”相关角色 */
export function isCommercialVehicleRole() {
    const info = getUserInfo();
    return Boolean(
        info &&
        ['paidrole', 'trialrole', 'touristrole'].includes(info.roleKey) &&
        info.menuName?.includes('商用车'),
    );
}

export function roleKeyItem() {
    const info = getUserInfo();
    return info?info.roleKey:'';
}


/**判断是否隐藏 */
export function ifHidden() {
    const info = getUserInfo();
    if (
        info &&
        ['paidrole', 'trialrole', 'touristrole'].includes(info.roleKey) &&
        info.userName === 'shfule'
    ) {
        return 1;
    }
    return 0;
}

/**设置用户信息 */
export function setUserInfo(data){
    // cookie.set('userInfo', JSON.stringify(data));
    // cookie.set('loginName', JSON.stringify(data.loginName));、
    let time = new Date(new Date().getTime() + 30 * 60 * 1000);
    cookie.set('userInfo', JSON.stringify(data),{ expires: time });

}

// 临时保存用户信息
export function restUserInfo(data) {
    // return cookie.set('userInfo', JSON.stringify(data));
    return cookie.set('userInfo', JSON.stringify(data));
}

/**删除用户信息 */
export function removeUserInfo() {
    // cookie.delete('userInfo');
    cookie.remove('userInfo');

}

/**获取用户登陆状态 */
export function getUserState() {
    // return Boolean(cookie.get('userState'));
    return Boolean(get('userState'));
}

/**设置用户登陆状态 */
export function setUserState(state) {
    set('userState', String(typeof state === 'boolean' ? state : Boolean(state)));
    // cookie.set('userState', String(typeof state === 'boolean' ? state : Boolean(state)), {
    //   expires: '7D',
    // });
}

/**临时用户登陆状态 */
export function restUserState(state) {
    // cookie.set('userState', String(Boolean(state)));
    set('userState', String(Boolean(state)));

}

/**删除用户登陆状态 */
export function removeUserState() {
    // cookie.delete('userState');
    remove('userState');
}

/**保存账号密码 */
export function setSecrecy(data) {
    set('secrecy', JSON.stringify(data), { expires: '7D' });
}

/**获取账号密码 */
export function getSecrecy() {
    const secrecy = cookie.get('secrecy');
    return secrecy ? JSON.parse(secrecy) : null;
}

/**临时保存账号密码 */
export function restSecrecy(data) {
    set('secrecy', JSON.stringify(data));
}

/**临时保存账号密码 */
export function deleteSecrecy() {
    remove('secrecy');
}
